import { Badge, BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import { SetStateAction } from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import { ActivePageType } from "../types/types";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const Navigation = ({ activePage, setActivePage, cartCounter, listCounter }: { activePage: ActivePageType, setActivePage: (value: SetStateAction<ActivePageType>) => void, cartCounter: number, listCounter: number }) => {
  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999 }} elevation={3}>
      <BottomNavigation
        showLabels
        value={activePage}
        onChange={(_event, newValue) => {
          setActivePage(newValue);
        }}
      >
        <BottomNavigationAction value="home" label="Posiłki" icon={<FastfoodIcon />} />
        <BottomNavigationAction value="cart" label="Koszyk" icon={
          <Badge badgeContent={cartCounter} color="primary">
            <ShoppingCartIcon />
          </Badge>
        } />
        <BottomNavigationAction value="menu" label="Kalendarz" icon={
            <CalendarMonthIcon />
        } />
        <BottomNavigationAction value="list" label="Zakupy" icon={
          <Badge badgeContent={listCounter} color="primary">
            <FormatListBulletedIcon />
          </Badge>
        } />
        <BottomNavigationAction value="settings" label="Ustawienia" icon={
          <SettingsIcon />
        } />
      </BottomNavigation>
    </Paper>
  )
}
